import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7742af01"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live-booking__cover" }
const _hoisted_2 = { class: "live-booking__title" }
const _hoisted_3 = { class: "live-booking-desc" }
const _hoisted_4 = { class: "live-booking__time" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-time" }, null, -1 /* HOISTED */))
const _hoisted_6 = { class: "live-booking__num" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-num" }, null, -1 /* HOISTED */))

import {withDefaults} from 'vue';
import {download, formatDate} from 'common/util';

interface Props {
    info: object;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    info: { default: null }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "live-booking",
    style: _normalizeStyle({backgroundImage: `url(${__props.info.cover_pic_url})`})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "100%",
        height: "100%",
        fit: "cover",
        radius: "40px",
        src: __props.info.cover_pic_url
      }, null, 8 /* PROPS */, ["src"])
    ]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.info.theme), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", null, "开播时间：" + _toDisplayString(_unref(formatDate)(__props.info.start_time * 1000)), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", null, "预约人数：" + _toDisplayString(__props.info.pre_num_str), 1 /* TEXT */)
      ])
    ]),
    _createVNode(_component_van_button, {
      class: "live-booking__btn",
      size: "large",
      text: "开播提醒",
      color: "linear-gradient(90deg, #FFA6D5 0%, #FE89C7 100%)",
      onClick: _unref(download)
    }, null, 8 /* PROPS */, ["onClick"])
  ], 4 /* STYLE */))
}
}

})